import { FC, Fragment } from 'react';

import {
  Content,
  Footer,
  Form,
  Section,
  Skeleton,
  Typography,
} from '@wearehelpful/ui-kit';
import { useTranslation } from '@wearehelpful/ui-localization';
import { useRoute } from '@core/navigation';
import { RoutePath } from '@common/constants';

import { MatchingSearch } from '../Matching.types';

import { TherapistForm } from './Index.types';
import { TherapistCard } from './_partitions/TherapistCard';
import { useMatching } from './Index.hook';

export const Index: FC = () => {
  const { t } = useTranslation();
  const [{ search }, { push }] = useRoute<{}, MatchingSearch>();

  const [
    {
      bestMatch,
      // other,
      loading,
      title,
      description,
    },
  ] = useMatching();

  const handleOnSubmit = async ({ therapist: id }: TherapistForm) => {
    push({
      search,
      path: RoutePath.THERAPISTS_MATCHING_SCHEDULE,
      params: { therapistId: id },
    });
  };

  return (
    <Form<TherapistForm> onSubmit={handleOnSubmit}>
      <Content>
        {bestMatch?.length && (
          <Fragment>
            <Content.Subheader>
              <Typography variant="h2">{title}</Typography>
            </Content.Subheader>
            <Content.Progress value={1 / 3} />
          </Fragment>
        )}
        <Content.Fixed>
          <Skeleton loading={loading} variant="feed">
            <Form.RadioToggle
              name="therapist"
              spacing="none"
              validation={{ required: true }}
            >
              <Form.Section description={description}>
                {!!bestMatch?.length && (
                  <Section>
                    <Section.Header>
                      <Section.Title>{t('forms.bestMatch')}</Section.Title>
                    </Section.Header>
                    <Section.Content>
                      {bestMatch?.map((item) => {
                        return <TherapistCard key={item.id} item={item} />;
                      })}
                    </Section.Content>
                  </Section>
                )}
                {/* {!!other?.length && (
                  <Section>
                    <Section.Header>
                      <Section.Title>
                        {t('forms.otherTherapistThatCouldSuitYou')}
                      </Section.Title>
                    </Section.Header>
                    <Section.Content>
                      {other?.map((item) => {
                        return <TherapistCard key={item.id} item={item} />;
                      })}
                    </Section.Content>
                  </Section>
                )} */}
              </Form.Section>
            </Form.RadioToggle>
          </Skeleton>
        </Content.Fixed>
      </Content>
      <Footer shadow>
        <Form.Submit checkValidity>{t('actions.next')}</Form.Submit>
      </Footer>
    </Form>
  );
};
